module.exports = __webpack_public_path__ + "static/hero-visual-c0f3638654aa869756748ed1d1831d6e.png";